import { parseInlineStyles } from '@progress/kendo-common';

export var setStyle = function (element, styleString) {
    var styles = parseInlineStyles(styleString);
    Object.keys(styles).forEach(function (key) {
        element.style[key] = styles[key];
    });
};

var styleAttr = 'data-style';
export var replaceStyleAttr = function (html) { return (html || '').replace(/\sstyle=/g, ' ' + styleAttr + '='); };
export var restoreStyleAttr = function (container) {
    Array.from(container.querySelectorAll('[' + styleAttr +']')).forEach(function (element) {
        var styleString = element.getAttribute(styleAttr);
        element.removeAttribute(styleAttr);
        setStyle(element, styleString);
    });
};

export var setInnerHTML = function (container, html) {
    container.innerHTML = replaceStyleAttr(html);
    restoreStyleAttr(container);
};
